import React, { Component } from 'react';
import _ from 'lodash';
import Charts from '../common/Charts'
import { Breadcrumb, Row, Col, Progress, Spin, Card, Avatar } from 'antd';

const { Meta } = Card;

class Utilization extends Component {
    constructor(props) {
      super(props);
      this.state = {
        config : {},
        filters: [],
        isLoading:true,
        portalUtilizationOverall: {filters:[], config: {}},
        wellnessUtilDeptLoc: {filters:[], config: {}},
        portalUtilizationActivity: {filters:[], config: {}},
        wellnessUtilTimeline: {filters:[], config: {}},
        moods: {},
        baseConfig : {
          filters: [],
          config: {
            chart: {renderTo: 'container'},
            title: {text: 'Wellness portal utilization', align: 'left', margin: 35},
            subtitle: { text: '', align: 'left' },
            xAxis: {},
            yAxis: {},
            credits: {
              enabled: false
            },
            series: []
          }
        }
      };
      this.wellnessUtilizationDepartmentCallback = this.wellnessUtilizationDepartmentCallback.bind(this)
      this.wellnessUtilTimelineCallback = this.wellnessUtilTimelineCallback.bind(this)
    }

    componentWillMount () {
      this.getPortalUtilizationOverall()
      this.getWellnessUtilizationDepartmentConfig()
      this.getWellnessUtilActivity()
      this.getWellnessUtilTimeline()
      this.getLoginSummary()
      this.getfeatureUsage()
      this.getMoods()
    }

    callback(key) {
      console.log(key);
    }
   
    getfeatureUsage () {
      let that = this;
      window.axios.get(window.API_URL + 'corporate/dashboard/utilizations/features')
      .then(function (response) {
        that.setState({featureUsage: response.data.series, isLoading:false})
      })
      .catch(function (error) {
        console.log(error);
      })
    }

    getLoginSummary () {
      let that = this;
      window.axios.get(window.API_URL + 'corporate/dashboard/utilizations/login-summary')
      .then(function (response) {
        that.setState({loginSummary: response.data.series})
      })
      .catch(function (error) {
        console.log(error);
      })
    }

    getMoods () {
      let that = this;
      window.axios.get(window.API_URL + 'corporate/dashboard/utilizations/moods-summary')
      .then(function (response) {
        that.setState({moods: response.data.moods, isLoading:false})
      })
      .catch(function (error) {
        console.log(error);
      })
    }
    
    getWellnessUtilTimeline () {
      let that = this;
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      window.axios.get(window.API_URL + 'corporate/dashboard/utilizations/timeline')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        let series = response.data.series.find( object => object.filter === response.data.filters[0] );
        baseConfig.config.subtitle.text = 'Weekly & Monthly wise distribution'
        baseConfig.config.series = series.series
        baseConfig.config.chart.type = 'line'
        baseConfig.config.xAxis = series.xAxis
        baseConfig.config.yAxis = series.yAxis
        that.setState({wellnessUtilTimeline: baseConfig, allWellnessUtilTimeline: response.data})
      })
      .catch(function (error) {
        console.log(error);
      })
    }

    wellnessUtilTimelineCallback (filter) {
      let series = this.state.allWellnessUtilTimeline.series.find( object => object.filter === filter );
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.filters = this.state.allWellnessUtilTimeline.filters
      baseConfig.config.subtitle.text = 'Weekly & Monthly wise distribution'
      baseConfig.config.series = series.series
      baseConfig.config.chart.type = 'line'
      baseConfig.config.xAxis = series.xAxis
      baseConfig.config.yAxis = series.yAxis
      this.setState({wellnessUtilTimeline: baseConfig})
    }

    getWellnessUtilActivity () {
      let that = this
      let baseConfig = {
        filters: [],
        config: {
          chart: {
              type: 'funnel'
          },
          title: {
              text: 'Wellness portal utilization',
              align: 'left'
          },
          subtitle: {
            text: '# of Employees',
            align: 'left'
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b> ({point.y:,.0f})',
                color: 'black',
                softConnector: true
              },
              center: ['45%', '50%'],
              neckWidth: '15%',
              neckHeight: '35%',
              width: '50%'
            }
          },
          legend: {
            enabled: false
          },
          credits: {
            enabled: false
          },
          series: [{
            name: 'Employees',
            data: []
          }]
        }
      }
      window.axios.get(window.API_URL + 'corporate/dashboard/utilizations/activity-counts')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        baseConfig.config.series[0].data = response.data.series[0].data
        that.setState({portalUtilizationActivity: baseConfig})
      })
      .catch(function (error) {
        console.log(error);
      })
    }
    getWellnessUtilizationDepartmentConfig () {
      let that = this;
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      window.axios.get(window.API_URL + 'corporate/dashboard/utilizations/counts-filtered')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        let series = response.data.series.find( object => object.filter === response.data.filters[0] );
        baseConfig.config.subtitle.text = 'Location, Department & Shift wise distribution'
        baseConfig.config.series = series.series
        baseConfig.config.chart.type = 'column'
        baseConfig.config.xAxis = series.xAxis
        baseConfig.config.yAxis = series.yAxis
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        that.setState({wellnessUtilDeptLoc: baseConfig, allWellnessUtilDeptLoc: response.data})
      })
      .catch(function (error) {
        console.log(error);
      })
    }

    wellnessUtilizationDepartmentCallback (filter) {
      let series = this.state.allWellnessUtilDeptLoc.series.find( object => object.filter === filter );
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.filters = this.state.allWellnessUtilDeptLoc.filters
      baseConfig.config.subtitle.text = 'Location, Department & Shift wise distribution'
      baseConfig.config.series = series.series
      baseConfig.config.chart.type = 'column'
      baseConfig.config.xAxis = series.xAxis
      baseConfig.config.yAxis = series.yAxis
      baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
      this.setState({wellnessUtilDeptLoc: baseConfig})
    }

    getPortalUtilizationOverall () {
      let that = this
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      window.axios.get(window.API_URL + 'corporate/dashboard/utilizations/counts')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        baseConfig.config.subtitle.text = 'Male vs Female'
        baseConfig.config.chart.type = 'column'
        baseConfig.config.xAxis = response.data.xAxis
        baseConfig.config.yAxis = response.data.yAxis
        baseConfig.config.series = response.data.series
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        that.setState({portalUtilizationOverall: baseConfig})
      })
      .catch(function (error) {
        console.log(error);
      })
  }
    render () {
      if(this.state.isLoading) {
        return (
          <div className="spiner">
            <Spin size="large"/>
          </div>
        )
      }
      let loginSummary = this.state.loginSummary ? this.state.loginSummary : []
      let featureUsage = this.state.featureUsage ? this.state.featureUsage : []
        return (
          <div>
            <Row>
              <Col span={12}>
                <Breadcrumb style={{paddingTop: 10, marginBottom: 20}}>
                  <Breadcrumb.Item><a href="/" style={{color: '#1890ff'}}>Home</a></Breadcrumb.Item>
                  <Breadcrumb.Item>Utilization</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
              <Col span={12}>
                <Row type="flex" justify="end" style={{marginTop: 10}}>
                  <h4 className="top-right-delay-label">Refreshes every <b> day </b></h4>
                </Row>
              </Col>
            </Row>    
            <div className="gutter-example">
              <Card>
                <Row gutter={16}>
                    <Col className="gutter-row" md={11} sm={24}>
                        <div className="gutter-box">
                            <Charts 
                            filters={this.state.portalUtilizationOverall.filters} 
                            config={this.state.portalUtilizationOverall.config}/>
                        </div>
                    </Col>
                    <Col span={2}/>
                    <Col className="gutter-row" md={11} sm={24}>
                        <div className="gutter-box">
                            <Charts 
                            callback={this.wellnessUtilizationDepartmentCallback}
                            filters={this.state.wellnessUtilDeptLoc.filters} 
                            config={this.state.wellnessUtilDeptLoc.config}/>
                        </div>
                    </Col>
                </Row>
              </Card>  
                <br></br>
              <Card>
                <Row gutter={16}>
                    <Col className="gutter-row" span={24}>
                        <div className="gutter-box">
                            <Charts callback={this.wellnessUtilTimelineCallback}
                            filters={this.state.wellnessUtilTimeline.filters} 
                            config={this.state.wellnessUtilTimeline.config}/>
                        </div>
                    </Col>
                </Row>
              </Card>
                <br></br>
              <Card>  
                <Row gutter={16}>
                    <Col className="gutter-row" md={11} sm={24}>
                        <div className="gutter-box">
                        <Row type="flex" justify="start" >
                            <h2 className="semibold">Frequency of usage</h2>
                        </Row>
                          {loginSummary.map(function(object, i){
                            return (
                              <Row>
                                <Col className="gutter-row" span={6}>
                                  <div className="gutter-box wellnessScoreText">
                                      <label>{object.name}</label>
                                  </div>
                                </Col>
                                <Col className="gutter-row" span={18}>
                                  <div className="gutter-box wellnessScoreText">
                                  <Progress percent={object.data} strokeColor="rgb(0, 196, 212)"/>
                                  </div>
                                </Col>
                              </Row>  
                            )
                          })}                            
                      </div>
                    </Col>
                    <Col span={2}/>
                    <Col className="gutter-row" md={11} sm={24}>
                        <div className="gutter-box">
                        <Row type="flex" justify="start">
                            <h2 className="semibold">Features usage</h2>
                        </Row>
                        
                          {featureUsage.map(function(object, i){
                            return (
                              <Row>
                                <Col className="gutter-row" span={6}>
                                  <div className="gutter-box wellnessScoreText">
                                    <label> {object.name}</label>
                                  </div>
                                </Col> 
                                <Col className="gutter-row" span={18}>
                                  <div className="gutter-box wellnessScoreText">
                                    <Progress percent={object.data} strokeColor="rgb(0, 196, 212)"/>
                                  </div>
                                </Col>
                              </Row>  
                            )
                          })}   
                        </div>
                    </Col>
                </Row>
              </Card>  
                <br></br>
                <Row gutter={16}>
                    {/* <Col className="gutter-row" span={12}>
                        <div className="gutter-box">
                        <Row type="flex" justify="space-around" align="middle" >
                            <h2>Overall company mood</h2>
                        </Row>
                        <Row>
                            <Col className="gutter-row" span={6}>
                                <div className="gutter-box wellnessScoreText">
                                    <label> Happy</label>
                                    <br></br>
                                    <label> Took Challenges</label>
                                </div>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="gutter-box wellnessScoreText">
                                    <label> Sad</label>
                                    <br></br>
                                    <label> Took Challenges</label>
                                </div>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="gutter-box wellnessScoreText">
                                    <label> Angry</label>
                                    <br></br>
                                    <label> Took Challenges</label>
                                </div>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="gutter-box wellnessScoreText">
                                    <label> Stressed</label>
                                    <br></br>
                                    <label> Took Challenges</label>
                                </div>
                            </Col>
                        </Row> 
                        </div>
                    </Col> */}
                </Row>
                <br/>
                <br/>
                <Row gutter={16}>
                  <h2 className='semibold'>Overall company mood</h2>
                  <Col sm = {24} md={6}>
                    <Card>
                      <Meta
                        avatar={<Avatar src="https://res.cloudinary.com/ekincare/image/upload/v1537944625/hr_dashboard_moods/happy-img.svg" />}
                        title={this.state.moods.happy + '%'}
                        description="Happy"
                      />
                    </Card>
                  </Col>
                  <Col sm = {24} md={6}>
                    <Card>
                      <Meta
                        avatar={<Avatar src="https://res.cloudinary.com/ekincare/image/upload/v1537944593/hr_dashboard_moods/sad-img.svg" />}
                        title={this.state.moods.sad + '%'}
                        description="Sad"
                      />
                    </Card>
                  </Col>
                  <Col sm = {24} md={6}>
                    <Card>
                      <Meta
                        avatar={<Avatar src="https://res.cloudinary.com/ekincare/image/upload/v1537944593/hr_dashboard_moods/angry-img.svg" />}
                        title={this.state.moods.angry + '%'}
                        description="Angry"
                      />
                    </Card>
                  </Col>
                  <Col sm = {24} md={6}>
                    <Card>
                      <Meta
                        avatar={<Avatar src="https://res.cloudinary.com/ekincare/image/upload/v1545285524/hr_dashboard_moods/stress-large.svg" />}
                        title={this.state.moods.stress + '%'}
                        description="Stressed"
                      />
                    </Card>
                  </Col>
                </Row>
                <br></br>
                
            </div>
          </div>  
        )
    }
}
export default Utilization;